import React, { useState } from "react"
import FormHeaderClient from "./controllers/FormHeaderClient.controller"
import ModalFormClient from "./controllers/clientForm/ModalFormClient.controller"
import {
  CLIENT_INITIAL_STATE,
  FORM_CLIENT_MODE,
} from "../../consts/modules/clients.consts"
import ClientDetails from "./controllers/clientDetails/ClientDetails.controller"

const Client = () => {
  const [selectedClient, setSelectedClient] = useState(CLIENT_INITIAL_STATE)
  const [showClientFormModal, setShowClientFormModal] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const triggerRefresh = () => {
    setRefresh(!refresh)
  }
  return (
    <>
      <FormHeaderClient isCreate={false} selectedClient={selectedClient} />
      <ClientDetails
        setSelectedClient={setSelectedClient}
        setShowClientFormModal={setShowClientFormModal}
        refresh={refresh}
      />
      <ModalFormClient
        visible={showClientFormModal}
        setVisible={setShowClientFormModal}
        mode={FORM_CLIENT_MODE.EDIT}
        selectedClient={selectedClient}
        triggerRefresh={triggerRefresh}
      />
    </>
  )
}

export default Client
